import axios from 'axios'
import user from './user'
import {handleError} from "../../common"

const state = {
    inmarsat: {
        emails: "",
        content: ""
    },

    billing: {
        emails: "",
        content: ""
    },
    mss: {
        emails: "",
        content: ""
    },
    loaded: false,

    terminalTypes: [],
    terminalTypesLoadMore: true,
    subscriptions: [],
    subscriptionsLoadMore: true,
};

const mutations = {
    setEmailSettings(state, settings) {
        state.inmarsat = settings.inmarsat;
        state.billing = settings.billing;
        state.mss = settings.mss;

    },
    setLXSettings(state, settings) {
        state.terminalTypes = settings.terminalTypes;
        state.subscriptions = settings.subscriptions;
    },
    setTerminalTypes(state, data) {
        if (data.append) {
            state.terminalTypes =  state.terminalTypes.concat(data.types);
        } else {
            state.terminalTypes = data.types;
        }
    },
    resetTerminalTypes(state) {
        state.terminalTypes = [];
        state.terminalTypesLoadMore = true;
    },
    resetSubscriptions(state) {
        state.subscriptions = [];
        state.subscriptionsLoadMore = true;
    },
    setLoadTypes(state, value) {
        state.terminalTypesLoadMore = value;
    },
    setLoadSubscriptions(state, value) {
        state.subscriptionsLoadMore = value;
    },
    setSubscriptions(state, subscriptions) {
        state.subscriptions =  state.subscriptions = subscriptions;
    },
    deleteType(state, id){
        state.terminalTypes = state.terminalTypes.filter(obj => {
            return obj.id !== id
        });
    },
    deleteSubscription(state, id){
        state.subscriptions = state.subscriptions.filter(obj => {
            return obj.id !== id
        });
    },
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
};

const actions = {
    getEmailSettings({commit}) {
        let config = {
            headers: {
                'Authorization': `Bearer ${user.state.token}`,
            },
        };
        return new Promise((resolve) => {
            axios.get('/api/settings/emails', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setEmailSettings', response.data.settings);
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    getLXSettings({commit}) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.get('/api/settings/lx-settings', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setLXSettings', response.data.settings);
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    getTerminalTypes({commit}, params = {}) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve) => {
            axios.get('/api/settings/terminal-types', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setTerminalTypes', {types: response.data.terminalTypes, append: params.page !== 1});
                        if (response.data.currentPage + 1 >= response.data.pages ) {
                            commit('setLoadTypes', false);
                        }
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    getSubscriptions({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve) => {
            axios.get('/api/settings/subscriptions', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setSubscriptions', response.data.subscriptions);
                        if (response.data.currentPage + 1 >= response.data.pages ) {
                            commit('setLoadSubscriptions', false);
                        }
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    saveSettings({commit}, params) {
        let config = {
            headers: {
                'Authorization': `Bearer ${user.state.token}`,
                'Content-Type': 'application/json'
            },
        };
        return new Promise((resolve) => {
            axios.post('/api/settings/save', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Settings updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    addType({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/add-type', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Item added",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    updateType({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/update-type', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Item Updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    deleteTerminalType({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/settings/delete-type', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Terminal type deleted",
                            type: "success",
                        } , { root: true });
                        commit('deleteType', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message ? response.data.message : "Delete Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },
    deleteSubscription({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/settings/delete-subscription', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Subscription deleted",
                            type: "success",
                        } , { root: true });
                        commit('deleteSubscription', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message ? response.data.message : "Delete Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },
    addSubscription({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/add-subscription', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Subscription added",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    updateSubscription({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/update-subscription', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Subscription Updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
